import { ArrowValue } from '@core/models/brijjsports.models';

export const PAD_VALUES: ArrowValue[] = ['X', 10, 9, 8, 7, 6, 5, 4, 3, 2, 1, 'M'];

export interface ArrowEditTarget {
  roundIndex: number;
  endIndex: number;
  arrowIndex: number;
}

export interface CoachScoringLiveState {
  activeIndex: number;
  activeRound: number;
  editTarget: ArrowEditTarget | null;
}

export const initialCoachScoringLiveState: CoachScoringLiveState = {
  activeIndex: 0,
  activeRound: 0,
  editTarget: null
};
